var __jsx = React.createElement;
import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/core";
const Australia = () => {
  return ___EmotionJSX("svg", {
    fill: "none",
    height: "15",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("mask", {
    height: "15",
    id: "a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("path", {
    d: "M0 0h20v15H0z",
    fill: "#fff"
  })), ___EmotionJSX("g", {
    mask: "url(#a)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0h20v15H0V0z",
    fill: "#2E42A5",
    fillRule: "evenodd"
  }), ___EmotionJSX("path", {
    d: "M0 0h11v9H0z",
    fill: "#2E42A5"
  }), ___EmotionJSX("mask", {
    height: "9",
    id: "b",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "11",
    x: "0",
    y: "0"
  }, ___EmotionJSX("path", {
    d: "M0 0h11v9H0z",
    fill: "#fff"
  })), ___EmotionJSX("g", {
    mask: "url(#b)"
  }, ___EmotionJSX("path", {
    d: "M-1.253 8.125 1.223 9.21l10.083-8.03 1.306-1.614-2.647-.363-4.113 3.46-3.31 2.332-3.795 3.129z",
    fill: "#F7FCFF"
  }), ___EmotionJSX("path", {
    d: "m-.914 8.886 1.261.63L12.143-.583h-1.77L-.915 8.886z",
    fill: "#F50100"
  }), ___EmotionJSX("path", {
    d: "M12.503 8.125 10.306 9.52-.056 1.18-1.362-.434l2.647-.363 4.113 3.46 3.31 2.332 3.795 3.129z",
    fill: "#F7FCFF"
  }), ___EmotionJSX("path", {
    d: "m12.418 8.67-1.261.63-5.023-4.323-1.489-.483-6.133-4.921H.283l6.13 4.804 1.628.58 4.377 3.714z",
    fill: "#F50100"
  }), ___EmotionJSX("mask", {
    fill: "#000",
    height: "11",
    id: "c",
    maskUnits: "userSpaceOnUse",
    width: "13",
    x: "-1",
    y: "-1"
  }, ___EmotionJSX("path", {
    d: "M-1-1h13v11H-1z",
    fill: "#fff"
  }), ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M6 0H5v4H0v1h5v4h1V5h5V4H6V0z",
    fillRule: "evenodd"
  })), ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M6 0H5v4H0v1h5v4h1V5h5V4H6V0z",
    fill: "#F50100",
    fillRule: "evenodd"
  }), ___EmotionJSX("path", {
    d: "M5 0v-.938h-.938V0H5zm1 0h.938v-.938H6V0zM5 4v.938h.938V4H5zM0 4v-.938h-.938V4H0zm0 1h-.938v.938H0V5zm5 0h.938v-.938H5V5zm0 4h-.938v.938H5V9zm1 0v.938h.938V9H6zm0-4v-.938h-.938V5H6zm5 0v.938h.938V5H11zm0-1h.938v-.938H11V4zM6 4h-.938v.938H6V4zM5 .937h1V-.938H5V.938zM5.938 4V0H4.063v4h1.875zM0 4.938h5V3.063H0v1.874zM.938 5V4H-.938v1H.938zM5 4.062H0v1.875h5V4.063zM5.938 9V5H4.063v4h1.875zM6 8.062H5v1.876h1V8.062zM5.062 5v4h1.875V5H5.063zM11 4.062H6v1.875h5V4.063zM10.062 4v1h1.876V4h-1.876zM6 4.938h5V3.063H6v1.874zM5.062 0v4h1.875V0H5.063z",
    fill: "#F7FCFF",
    mask: "url(#c)"
  }))), ___EmotionJSX("path", {
    d: "m5.92 12.278-.82.758.081-1.113-1.104-.17.922-.63-.557-.968 1.068.327.41-1.039.41 1.039 1.068-.327-.557.968.922.63-1.104.17.081 1.113-.82-.758zM13.24 8.297l-.547.505.054-.743-.735-.112.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.645.613.421-.736.112.055.743-.547-.505zM14.52 2.963l-.547.506.054-.743-.735-.112.614-.42-.371-.646.712.218.273-.693.273.693.712-.218-.37.645.613.42-.736.113.055.743-.547-.506zM17.72 5.63l-.547.505.054-.742-.735-.113.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.646.613.42-.736.113.055.742-.547-.505zM15.16 13.297l-.547.505.054-.742-.735-.113.614-.42-.371-.646.712.218.273-.692.273.692.712-.218-.37.646.613.42-.736.113.055.742-.547-.505zM17.4 9.14l-.555.291.106-.618-.45-.438.621-.09.278-.563.278.562.62.09-.449.439.106.618-.555-.292z",
    fill: "#F7FCFF"
  }));
};
export default Australia;
//# sourceMappingURL=Australia.js.map
// @zapier/checkout@7.13.0 (cd15c152f)
